import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { fetchEmployeeOffices } from "actions";
import { find, map } from "lodash";
import { CustomDropdownContainer } from "CommonComponent";

const OfficeDropdown = ({
  officeValue,
  officeOnChange,
  label = "Office",
  placeholder = "Select office",
  name = "office_id",
  isDisabled = false,
  required = false,
}) => {
  const dispatch = useDispatch();
  const officesList = useSelector((state) => state.employeeState.officesList);
  const isOfficesLoading = useSelector((state) => state.employeeState.isOfficesLoading);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if ((!officesList || officesList.length === 0) && !isOfficesLoading) {
      dispatch(fetchEmployeeOffices());
    }
  }, [dispatch, officesList, isOfficesLoading]);

  useEffect(() => {
    if (!officesList || officesList.length === 0) {
      setOptions(
        officeValue?.value
          ? [{ value: officeValue.value, label: officeValue.label || String(officeValue.value) }]
          : []
      );
      return;
    }

    const formattedOptions = map(officesList, (item) => ({
      value: item.id,
      label: item.name || item.title || item.office_name || String(item.id),
    }));

    if (officeValue?.value != null && !find(formattedOptions, (o) => String(o.value) === String(officeValue.value))) {
      formattedOptions.unshift({
        value: officeValue.value,
        label: officeValue.label || String(officeValue.value),
      });
    }

    setOptions(formattedOptions);
    // officeValue omitted from deps — value object identity changes every parent
    // render and would keep rebuilding options during route transitions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officesList, officeValue?.value, officeValue?.label]);

  return (
    <Form.Group className="mb-3">
      <Form.Label className={`label-input${required ? " label-input--required" : ""}`}>{label}</Form.Label>
      <Select
        name={name}
        options={options}
        value={officeValue}
        onChange={officeOnChange}
        isMulti={false}
        placeholder={placeholder}
        className="multi-select w-100"
        classNamePrefix="react-select"
        isSearchable
        isClearable
        isDisabled={isDisabled}
        components={{ ValueContainer: CustomDropdownContainer }}
      />
    </Form.Group>
  );
};

OfficeDropdown.propTypes = {
  officeOnChange: PropTypes.func.isRequired,
  officeValue: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default OfficeDropdown;
